import { render, staticRenderFns } from "./RoomStatusTagItem.vue?vue&type=template&id=15944c36&scoped=true"
import script from "./RoomStatusTagItem.vue?vue&type=script&lang=js"
export * from "./RoomStatusTagItem.vue?vue&type=script&lang=js"
import style0 from "./RoomStatusTagItem.vue?vue&type=style&index=0&id=15944c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15944c36",
  null
  
)

export default component.exports